import client from 'data/client';
import { Brand } from 'data/types/brand';
import { normalizeBrand } from 'model/brand';

const getBrands = async () => {
  const response = await client.get<Brand[]>('/brands');

  return response.data.map(normalizeBrand);
};

export default getBrands;
